<div class="p-grid" [ngClass]="{ 'mb-20': hasMarginBottom }">
  <div [ngClass]="{ 'p-col-6': !isViewMode, 'p-col-12': isViewMode }">
    <h2 class="mv-0">
      {{ "SigvLibrary.TrackingRecords" | translate }}
      <span class="p-text-primary p-ml-2">{{ processLogs.length }}</span>
    </h2>
    <div class="cfc-list h-100px mt-10 mb-5">
      <ul class="cfc-list-wrapper">
        <li class="cfc-list-item" *ngFor="let record of processLogs">
          <div class="p-text-primary">
            {{ record.nodeName }}：{{ record.completeAction }}
          </div>
          <div>
            {{ record.applicant }}
            <span class="p-text-secondary">{{ record.time }}</span>
          </div>
          <div class="p-white-space-pre-line">
            {{ record.comment }}
          </div>
        </li>
      </ul>
    </div>
    <div class="float-right">
      <a href="#" class="link" (click)="toggleDialog($event)">
        {{ "SigvLibrary.ViewAll" | translate }}
      </a>
    </div>
  </div>
  <div class="p-col-6" *ngIf="!isViewMode">
    <h2 class="mv-0">
      {{ "SigvLibrary.Description" | translate }}
    </h2>
    <div class="p-fluid">
      <div class="p-field mt-10 mb-0">
        <textarea
          #descriptionTextareaModel="ngModel"
          name="descriptionTextarea"
          pInputTextarea
          [autoResize]="true"
          class="h-100px process-log"
          [(ngModel)]="description"
          [placeholder]="'SigvLibrary.PleaseInput' | translate"
          (ngModelChange)="changeDescription()"
          [maxLength]="1000"
          [required]="isDescriptionRequired"
        ></textarea>
        <small
          class="p-error"
          *ngIf="
            !isViewMode &&
            isDescriptionRequired &&
            (descriptionTextareaModel.dirty ||
              descriptionTextareaModel.touched) &&
            descriptionTextareaModel.errors?.required
          "
        >
          {{
            "SigvLibrary.ValidateRequired"
              | translate: { fieldName: "SigvLibrary.Description" | translate }
          }}
        </small>
        <small class="float-right">
          <span>{{ description.length }}</span>
          &nbsp;/&nbsp;
          <span class="p-text-primary">1000</span>
        </small>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="isShowDialog"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-lg"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h1>
      {{ "SigvLibrary.TrackingRecords" | translate }}
      <span class="p-text-primary ml-10">{{ processLogs.length }}</span>
    </h1>
  </ng-template>
  <div
    class="cfc-list cfc-max-height-560"
    *ngIf="processLogs && processLogs.length > 0"
  >
    <ul class="cfc-list-wrapper">
      <li class="cfc-list-item" *ngFor="let record of processLogs">
        <div class="p-text-primary">
          {{ record.nodeName }}：{{ record.completeAction }}
        </div>
        <div>
          {{ record.applicant }}
          <span class="p-text-secondary">{{ record.time }}</span>
        </div>
        <div *ngIf="record.comment" class="p-white-space-pre-line">
          {{ record.comment }}
        </div>
      </li>
    </ul>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-text-center">
      <button
        pButton
        type="button"
        [label]="'SigvLibrary.Ok' | translate"
        class="p-content-button p-mr-2 p-button-secondary"
        (click)="toggleDialog($event)"
      ></button>
    </div>
  </ng-template>
</p-dialog>
